<script>
import {Line} from "vue-chartjs";

export default {
    name: 'LineChart',
    extends: Line,
    props: {
        data: Object,
        title: Object,
        xAxesGridLines: {
            type: Boolean,
            default: true
        },
        yAxesGridLines: {
            type: Boolean,
            default: true
        },
        legendLabel: {
            type: Object,
            default: () => ({
                display: true,
                labels: {
                    boxWidth: 9,
                    usePointStyle: true,
                    fontSize: 14,
                    fontColor: '#8A97AA',
                    padding: 30,
                }
            })
        }
    },
    data() {
        return {
            // data demo
            // data: {
            //     labels: [
            //         "January",
            //         "February",
            //         "March",
            //         "April",
            //         "May",
            //         "June",
            //         "July"
            //     ],
            //     datasets: [
            //         {
            //             label: "Data 1",
            //             data: [2, 10, 5, 9, 0, 6, 20],
            //             backgroundColor: "transparent",
            //             borderColor: "rgba(1, 116, 188, 0.50)",
            //             pointBackgroundColor: "rgba(171, 71, 188, 1)"
            //         }
            //     ]
            // },
            // title: {
            //     display: true,
            //     text: "My Data",
            //     position: 'bottom'
            // }
        }
    },
    mounted() {
        this.render()
    },
    methods: {
        render () {
            this.renderChart(
                {
                    labels: this.data.labels,
                    datasets: this.data.datasets
                },
                {
                    hover: {
                        intersect: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    title: this.title,
                    legend: this.legendLabel,
                    plugins: {
                        datalabels: {
                            display: false,
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: this.xAxesGridLines
                                },
                                ticks: {
                                    fontSize: 14,
                                    fontColor: '#8A97AA'
                                },
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    display: this.yAxesGridLines
                                },
                                ticks: {
                                    min: 0,
                                    fontSize: 14,
                                    fontColor: '#8A97AA'
                                },
                            }
                        ]
                    },
                    tooltips: {
                        displayColors: false,
                        backgroundColor: '#000000',
                        titleFontSize: 14,
                        titleFontStyle: 'normal',
                        titleFontColor: '#FFFFFF',
                        bodyFontColor: '#FFFFFF',
                        bodyFontSize: 14,
                        xPadding: 12,
                        yPadding: 12,
                    }
                }
            )
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function () {
                this.render()
            }
        }
    }
};
</script>
